import {inject, Injectable} from '@angular/core';

import {Perspective} from '@selpia/shared/models';

import {PerspectiveStore} from '../state/perspective.store';

@Injectable({
  providedIn: 'root',
})
export class PerspectiveUpdateFacade {
  readonly #store: PerspectiveStore = inject(PerspectiveStore);

  setPerspective(perspective: Perspective): void {
    this.#store.setPerspective(perspective);
  }
}
